export class ProductPrototyp {
  public name:string = null
  public id:string = null
  public uom_id = null
  public route_ids = null
  public seller_id = null
  public default_code_tmpl = null
  public description = null
  public supplier_product_code = null
  public supplier_code_search = null
  public active = null
  public write_date = null

  constructor(){}

  // Liefert alle Attribute des Prototypen
  public get_attributs():Array<string>{
    let prototyp = new ProductPrototyp();
    let keys = Object.keys(prototyp);
    return keys;
  }

  // Liefert alle Subobjektdefinition
  public get_sub_object_definition(){
    let sub_object_fields = []
    let prototyp = new ProductPrototyp();
    let keys = Object.keys(prototyp);
    for (let key of keys){
      if (prototyp[key] !== null && prototyp[key].length !== 0){
        sub_object_fields.push(prototyp[key][0]);
      }
    }
    return sub_object_fields;
  }
}



// WEBPACK FOOTER //
// ./src/assets/shared/products.object.ts